import React from 'react';
import { Drawer, useMediaQuery, useTheme } from '@material-ui/core';
import { DrawerProps } from '@material-ui/core/Drawer/Drawer';
import { makeStyles } from '@material-ui/core/styles';
import { CloseIcon } from 'assets/svg';

const useStyle = makeStyles(theme => ({
  paper: {
    padding: '32px 24px',
    maxWidth: 320,
    width: '100%',
    boxShadow: '0px 16px 40px rgba(171, 182, 200, 0.39)',
    borderRadius: '0',

    [theme.breakpoints.down('xs')]: {
      padding: '48px 24px',
      maxWidth: 'none',
    },
  },

  scroll: {
    '& .MuiDrawer-paper': {
      overflowY: 'clip',
    },
  },

  drawer: {
    '& .MuiBackdrop-root': {
      backgroundColor: '#333',
      opacity: '.3 !important',
    },
  },

  backButton: {
    padding: 8,
    backgroundColor: '#F1F5F9',
    borderRadius: 8,
    cursor: 'pointer',
    height: 32,
    width: 32,
    position: 'absolute',
    right: 24,
  },
}));

interface IProp {
  /** Отображение затемненного бекграунда */
  backdropInvisible?: boolean;
  isOpenConfirmModal?: boolean;
  showBackButton?: boolean;
  onClose: () => void;
}

export const DrawerContainer: React.FC<IProp & DrawerProps> = ({
  children,
  backdropInvisible = false,
  isOpenConfirmModal = false,
  showBackButton = false,
  onClose,
  ...rest
}) => {
  const classes = useStyle();
  const theme = useTheme();
  const matchesMobile = useMediaQuery(theme.breakpoints.down('xs'), { noSsr: true });
  return (
    <Drawer
      classes={{
        paper: classes.paper,
      }}
      className={`${classes.drawer} ${isOpenConfirmModal ? classes.scroll : ''}`}
      onClose={onClose}
      {...rest}
      ModalProps={{
        BackdropProps: {
          invisible: backdropInvisible,
        },
      }}
    >
      <>
        {matchesMobile && showBackButton && (
          <span
            onClick={onClose}
            className={classes.backButton}
          >
            <CloseIcon />
          </span>
        )}
        {children}
      </>
    </Drawer>
  );
};
